import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";
import Dayjs from "dayjs";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  getContactName,
  getGroupLogotype,
} from "@vocollege/app/dist/modules/VoHelpers";
import { GeneralObject } from "@vocollege/app/dist/global";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";
import DecorSvg from "@vocollege/theme/dist/images/vodecor.svg";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";

const TutorAwardCertificateTemplate: React.FC<TemplateProps> = (props) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);
  const [decorImage, setDecorImage] = useState<any>(null);

  // Methods.

  const setImage = async () => {
    let output: GeneralObject[] = [];
    try {
      let logoToConvert = LogoSvg;
      if (item.college) {
        getGroupLogotype(item.college, "logo", output);
        if (output.length > 0) {
          logoToConvert = output[0].url;
        }
      }
      let convertedLogo = await convertSvgToImage(logoToConvert, 260);
      setLogotype(convertedLogo);
    } catch (error) {
      console.error(error);
    }
  };

  const setDecor = async () => {
    try {
      let convertedImage = await convertSvgToImage(DecorSvg, 1500);
      setDecorImage(convertedImage);
    } catch (error) {
      console.error(error);
    }
  };

  const getDate = () => {
    return item ? Dayjs(item.date).format("D MMMM YYYY") : "";
  };

  // Effects.

  useEffect(() => {
    if (item) {
      setImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  useEffect(() => {
    setDecor();
  }, []);

  return (
    // @ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={(baseStyles.page, styles.page)} wrap={false}>
        <View style={styles.decorWrapper}>
          {decorImage && (
            <ReactPdfImage src={decorImage} style={styles.decor} />
          )}
        </View>
        <View style={styles.contentWrapper}>
          <View style={baseStyles.section}>
            <Text style={styles.title}>
              {I18n.get.tutorAwardCertificate.template.title}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.subtitle}>
              {I18n.get.tutorAwardCertificate.template.subtitle}
            </Text>
            {item.college && (
              <Text style={styles.subtitle}>{item.college.title}</Text>
            )}
          </View>
          <View style={styles.section}>
            <Text style={styles.hasChosen}>
              {I18n.get.tutorAwardCertificate.template.has}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.tutorOfTheYear}>
              {I18n.trans(
                I18n.get.tutorAwardCertificate.template.tutorOfTheYear,
                { year: item.year },
              )}
            </Text>
          </View>
          <View style={[baseStyles.section, styles.textWrapper]}>
            <Text style={styles.text}>{item.text}</Text>
          </View>

          <View style={baseStyles.grow}></View>

          <View style={[baseStyles.section, styles.footer]}>
            <View style={styles.signatures}>
              {item && item.president && item.president !== "" && (
                <View style={styles.signature}>
                  <Text style={styles.signaturePerson}>
                    {item.president}
                    {/* {getContactName(item.president)} */}
                  </Text>
                  <Text style={styles.signatureTitle}>
                    {I18n.trans(
                      I18n.get.tutorAwardCertificate.template.presidentAt,
                      { college: item.college ? item.college.title : "" },
                    )}
                  </Text>
                  <Text style={styles.dateRow}>
                    {item.place}, {getDate()}
                  </Text>
                </View>
              )}
            </View>

            <View style={styles.logoWrapper}>
              {logotype && (
                <ReactPdfImage src={logotype} style={baseStyles.logo} />
              )}
              <Text style={[styles.text, styles.certifiedCollaboration]}>
                {I18n.get.tutorAwardCertificate.template.certifiedCollaboration}
              </Text>
            </View>

            {/* <View style={baseStyles.section}>
              <Text style={styles.text}>
                {I18n.get.tutorAwardCertificate.template.certifiedCollaboration}
              </Text>
            </View> */}
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default TutorAwardCertificateTemplate;
